var map = {
	"./HK.png": 8253,
	"./SGP.png": 8408,
	"./US.png": 4352,
	"./UnionPay.png": 4255,
	"./bg.png": 5378,
	"./bot.png": 9352,
	"./mastercard-w.png": 2110,
	"./mastercard.png": 5404,
	"./visa-w.png": 7605,
	"./visa.png": 2615,
	"./xcard-2.png": 9544,
	"./xcard-3.png": 7239,
	"./xcard-4.png": 4058,
	"./xcard.png": 4359,
	"./zd.png": 6990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2307;